export default "__VITE_ASSET__YOjSs$rI__"